import { CustomerType } from "@origin-digital/platform-enums";
import {
  CommonParameters,
  IMcAppType,
  NavFlow,
  EXISTS_STRING,
  Tab,
} from "../mcApp.types";

const properties: NonNullable<IMcAppType["parameters"]>["properties"] = {
  caid: CommonParameters.caid,
  product: {
    description: "Allowed values are 'lpg'",
    type: "string",
  },
  customerNumber: CommonParameters.customerNumber,
  orderNumber: {
    description: "the order number for the last LPG order that was processed",
    type: "string",
  },
  amount: {
    type: "string",
    description: "Account to pay in $, example '123.24'",
  },
};

export const paymentMake: IMcAppType = {
  name: "paymentMake_SAP",
  path: "/my-account/pay",
  description: "Make a payment",
  parameters: { properties },
  navFlow: NavFlow.FOCUS,
  title: "Make a payment",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentMake",
    customerType: CustomerType.sap,
  },
};

export const paymentMake_LPG: IMcAppType = {
  name: "paymentMake_LPG",
  path: "/my/make-lpg-payment",
  description: "Make a payment",
  parameters: {
    required: ["customerNumber"],
    properties,
  },
  navFlow: NavFlow.FOCUS,
  title: "Make a payment",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentMake",
    customerType: CustomerType.kraken,
    parameters: {
      customerNumber: EXISTS_STRING,
    },
  },
};

export const paymentMake_KRAKEN: IMcAppType = {
  name: "paymentMake_KRAKEN",
  path: "/my/make-payment/:accountNumber?",
  description: "Make a payment",
  parameters: {
    properties: {
      accountNumber: CommonParameters.accountNumber,
    },
  },
  navFlow: NavFlow.FOCUS,
  title: "Make a payment",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentMake",
    customerType: CustomerType.kraken,
  },
};

export const paymentMake_UNAUTH: IMcAppType = {
  name: "paymentMake_UNAUTH",
  path: "/pay",
  description: "Unauth make a payment",
  parameters: { properties },
  navFlow: NavFlow.FOCUS,
  title: "Make a payment",
  parent: Tab.MORE,
  conditions: {
    intent: "paymentMake",
    customerType: CustomerType.unauthenticated,
  },
};
